import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';


import { AppStorageService } from '../share/appstorage.service';
import { AppSettings } from '../../settings';
import { UserModel } from './user.model';


@Injectable()
export class AuthService {

    constructor(private httpClient: HttpClient,
        private router: Router,
        private appsettings: AppSettings,
        private appStorageService: AppStorageService) {
    }

    login(username: string, password: string) {
        return this.httpClient.post<any>(this.appsettings.apiUrl + 'users/login', {
            UserName: username,
            Password: password
        });
    }

    logout() {
        this.appStorageService.removeUser();
        this.router.navigate(['/signin']);
    }

    verifyUser(password: string) {
        return this.httpClient.get<any>(this.appsettings.apiUrl + 'users/verify?password=' + password, {
            observe: 'body',
            responseType: 'json'
        })
        .map((response) => {
            return response;
        });
    }

    isAuthenticated() {
        return !!this.appStorageService.getAccessToken();
    }

    getAuthorizationHeader() {

        return 'Bearer ' +  this.appStorageService.getSessionId() + ' ' + this.appStorageService.getAccessToken();
    }

    getUser() {
        return this.httpClient.get(this.appsettings.apiUrl + 'users/getuser')
            .map(
                (response) => {
                const user = response as UserModel;
                return user;
        });
    }

    httpGetUsers(partnerId: number) {
        let httpParams = new HttpParams();

        if (partnerId != null)
            httpParams = httpParams.set('PartnerId', partnerId.toString());

        return this.httpClient.get(this.appsettings.apiUrl + 'users/getusers' , {
            observe: 'body',
            responseType: 'json',
            params: httpParams
            })
            .map(
                (response) => {
                const users: UserModel[] = response['users'];

                return users;
        });
    }

    httpChangePassword(password: string, newPassword: string, newPasswordConfirm: string) {
        const requestChangePassword: any = {
            OldPassword: password,
            NewPassword: newPassword,
            ConfirmNewPassword: newPasswordConfirm
        };

        return this.httpClient.put(this.appsettings.apiUrl + 'users/changepassword/', requestChangePassword);
    }

    hasRole(role: string) {
      const roles = this.appStorageService.getUserRole();
      for (const ro of roles) {
          if (ro.roleid === role) {
            return true;
          }
      }
      return false;
  }

  forbiddenRole(role: string) {
    const roles = this.appStorageService.getUserRole();
    for (const ro of roles) {
        if (ro.roleid === role) {
          return false;
        }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/auth/auth.service.ts